export default function Quote() {
    return (
        <section className="bg-[#e8e2db] py-12 px-6">
            <div className="max-w-3xl mx-auto text-center">
                <h2 className="text-3xl md:text-4xl font-normal text-gray-900 mb-4">Reading Is More Than Finishing Books</h2>
                <p className="text-lg md:text-xl text-gray-700">It's about feelings, comfort, discovery, and the stories that stay with you. Bookshelf is designed to celebrate every part of your reading life—the cozy afternoons, the unexpected discoveries, the books that change you, and the community that shares your love for stories.</p>
            </div>
            <div className="max-w-3xl mx-auto text-center border-t-2 border-gray-300 mt-12 pt-8">
                <p><b>We value your privacy.</b> Bookshelf is completely ad-free and always will be. Your reading data is yours—we'll never sell it, share it, or use it for anything other than making your experience better.</p>
            </div>
        </section>
    );
}